<div class="white-label-design-service">
  <div class="page-body">
    <router-outlet></router-outlet>
  </div>
  <wl-privacy-terms></wl-privacy-terms>
</div>

<p-toast position="bottom-right" [key]="ToastKeys.httpError" />
